/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string | Date; output: string | Date; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type AddProjectMemberError = AlreadyExistsError | DbError | InvalidEmailError | NotFoundError | ProjectMemberInvitedByEmail | ProjectMembersMustBeVerified | ProjectMembersMustBeVerifiedForRole;

export type AddProjectMemberInput = {
  canInvite: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
  role: ProjectRole;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  usernameOrEmail?: InputMaybe<Scalars['String']['input']>;
};

export type AddProjectMemberPayload = {
  errors?: Maybe<Array<AddProjectMemberError>>;
  project?: Maybe<Project>;
};

export type AddProjectToOrgError = DbError | NotFoundError;

export type AddProjectToOrgInput = {
  orgId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type AddProjectToOrgPayload = {
  errors?: Maybe<Array<AddProjectToOrgError>>;
  organization?: Maybe<Organization>;
};

export type AddProjectsToOrgError = DbError | NotFoundError;

export type AddProjectsToOrgInput = {
  orgId: Scalars['UUID']['input'];
  projectIds: Array<Scalars['UUID']['input']>;
};

export type AddProjectsToOrgPayload = {
  errors?: Maybe<Array<AddProjectsToOrgError>>;
  orgById?: Maybe<OrgById>;
};

export type AlreadyExistsError = Error & {
  message: Scalars['String']['output'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type AskToJoinProjectError = DbError | NotFoundError | ProjectHasNoManagers | ProjectMembersMustBeVerified | ProjectMembersMustBeVerifiedForRole;

export type AskToJoinProjectInput = {
  projectId: Scalars['UUID']['input'];
};

export type AskToJoinProjectPayload = {
  errors?: Maybe<Array<AskToJoinProjectError>>;
  project?: Maybe<Project>;
};

export type AuthUserOrg = {
  orgId: Scalars['UUID']['output'];
  role: OrgRole;
};

export type AuthUserProject = {
  projectId: Scalars['UUID']['output'];
  role: ProjectRole;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkAddOrgMembersError = DbError | NotFoundError | UnauthorizedAccessError;

export type BulkAddOrgMembersInput = {
  orgId: Scalars['UUID']['input'];
  role: OrgRole;
  usernames: Array<Scalars['String']['input']>;
};

export type BulkAddOrgMembersPayload = {
  bulkAddOrgMembersResult?: Maybe<BulkAddOrgMembersResult>;
  errors?: Maybe<Array<BulkAddOrgMembersError>>;
};

export type BulkAddOrgMembersResult = {
  addedMembers: Array<OrgMemberRole>;
  existingMembers: Array<OrgMemberRole>;
  notFoundMembers: Array<OrgMemberRole>;
};

export type BulkAddProjectMembersError = DbError | InvalidEmailError | NotFoundError;

export type BulkAddProjectMembersInput = {
  passwordHash: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
  role: ProjectRole;
  usernames: Array<Scalars['String']['input']>;
};

export type BulkAddProjectMembersPayload = {
  bulkAddProjectMembersResult?: Maybe<BulkAddProjectMembersResult>;
  errors?: Maybe<Array<BulkAddProjectMembersError>>;
};

export type BulkAddProjectMembersResult = {
  addedMembers: Array<UserProjectRole>;
  createdMembers: Array<UserProjectRole>;
  existingMembers: Array<UserProjectRole>;
};

export type ChangeOrgMemberRoleError = DbError | NotFoundError | OrgMembersMustBeVerified | OrgMembersMustBeVerifiedForRole;

export type ChangeOrgMemberRoleInput = {
  orgId: Scalars['UUID']['input'];
  role?: InputMaybe<OrgRole>;
  userId: Scalars['UUID']['input'];
};

export type ChangeOrgMemberRolePayload = {
  errors?: Maybe<Array<ChangeOrgMemberRoleError>>;
  organization?: Maybe<Organization>;
};

export type ChangeOrgNameError = DbError | NotFoundError | RequiredError;

export type ChangeOrgNameInput = {
  name: Scalars['String']['input'];
  orgId: Scalars['UUID']['input'];
};

export type ChangeOrgNamePayload = {
  errors?: Maybe<Array<ChangeOrgNameError>>;
  organization?: Maybe<Organization>;
};

export type ChangeProjectDescriptionError = DbError | NotFoundError;

export type ChangeProjectDescriptionInput = {
  description: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
};

export type ChangeProjectDescriptionPayload = {
  errors?: Maybe<Array<ChangeProjectDescriptionError>>;
  project?: Maybe<Project>;
};

export type ChangeProjectMemberRoleError = DbError | NotFoundError | ProjectMembersMustBeVerified | ProjectMembersMustBeVerifiedForRole;

export type ChangeProjectMemberRoleInput = {
  projectId: Scalars['UUID']['input'];
  role: ProjectRole;
  userId: Scalars['UUID']['input'];
};

export type ChangeProjectMemberRolePayload = {
  errors?: Maybe<Array<ChangeProjectMemberRoleError>>;
  projectUsers?: Maybe<ProjectUsers>;
};

export type ChangeProjectNameError = DbError | NotFoundError | RequiredError;

export type ChangeProjectNameInput = {
  name: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
};

export type ChangeProjectNamePayload = {
  errors?: Maybe<Array<ChangeProjectNameError>>;
  project?: Maybe<Project>;
};

export type ChangeUserAccountByAdminError = DbError | NotFoundError | UniqueValueError;

export type ChangeUserAccountByAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<FeatureFlag>>;
  name: Scalars['String']['input'];
  role: UserRole;
  userId: Scalars['UUID']['input'];
};

export type ChangeUserAccountByAdminPayload = {
  errors?: Maybe<Array<ChangeUserAccountByAdminError>>;
  user?: Maybe<User>;
};

export type ChangeUserAccountBySelfError = DbError | NotFoundError | UniqueValueError;

export type ChangeUserAccountBySelfInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type ChangeUserAccountBySelfPayload = {
  errors?: Maybe<Array<ChangeUserAccountBySelfError>>;
  meDto?: Maybe<MeDto>;
};

export type Changeset = {
  branch: Scalars['String']['output'];
  date: Array<Scalars['Float']['output']>;
  desc: Scalars['String']['output'];
  node: Scalars['String']['output'];
  parents: Array<Scalars['String']['output']>;
  phase: Scalars['String']['output'];
  rev: Scalars['Int']['output'];
  tags: Array<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type CreateGuestUserByAdminError = DbError | NotFoundError | RequiredError | UniqueValueError;

export type CreateGuestUserByAdminInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['UUID']['input']>;
  passwordHash: Scalars['String']['input'];
  passwordStrength: Scalars['Int']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGuestUserByAdminPayload = {
  errors?: Maybe<Array<CreateGuestUserByAdminError>>;
  lexAuthUser?: Maybe<LexAuthUser>;
};

export type CreateOrganizationError = DbError;

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
};

export type CreateOrganizationPayload = {
  errors?: Maybe<Array<CreateOrganizationError>>;
  organization?: Maybe<Organization>;
};

export type CreateProjectError = AlreadyExistsError | DbError | ProjectCreatorsMustHaveEmail;

export type CreateProjectInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  forceDraft?: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  isConfidential: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['UUID']['input']>;
  projectManagerId?: InputMaybe<Scalars['UUID']['input']>;
  retentionPolicy: RetentionPolicy;
  type: ProjectType;
};

export type CreateProjectPayload = {
  createProjectResponse?: Maybe<CreateProjectResponse>;
  errors?: Maybe<Array<CreateProjectError>>;
};

export type CreateProjectResponse = {
  id: Scalars['UUID']['output'];
  result: CreateProjectResult;
};

export enum CreateProjectResult {
  Created = 'CREATED',
  Requested = 'REQUESTED'
}

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DbError = Error & {
  code: DbErrorCode;
  message: Scalars['String']['output'];
};

export enum DbErrorCode {
  Duplicate = 'DUPLICATE',
  DuplicateProjectCode = 'DUPLICATE_PROJECT_CODE',
  Unknown = 'UNKNOWN'
}

export type DeleteDraftProjectError = DbError | NotFoundError;

export type DeleteDraftProjectInput = {
  draftProjectId: Scalars['UUID']['input'];
};

export type DeleteDraftProjectPayload = {
  draftProject?: Maybe<DraftProject>;
  errors?: Maybe<Array<DeleteDraftProjectError>>;
};

export type DeleteOrgError = DbError;

export type DeleteOrgInput = {
  orgId: Scalars['UUID']['input'];
};

export type DeleteOrgPayload = {
  errors?: Maybe<Array<DeleteOrgError>>;
  organization?: Maybe<Organization>;
};

export type DeleteUserByAdminOrSelfError = DbError | NotFoundError;

export type DeleteUserByAdminOrSelfInput = {
  userId: Scalars['UUID']['input'];
};

export type DeleteUserByAdminOrSelfPayload = {
  errors?: Maybe<Array<DeleteUserByAdminOrSelfError>>;
  user?: Maybe<User>;
};

export type DraftProject = {
  code: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgId?: Maybe<Scalars['UUID']['output']>;
  projectManager?: Maybe<User>;
  projectManagerId?: Maybe<Scalars['UUID']['output']>;
  retentionPolicy: RetentionPolicy;
  type: ProjectType;
  updatedDate: Scalars['DateTime']['output'];
};

export type DraftProjectFilterInput = {
  and?: InputMaybe<Array<DraftProjectFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isConfidential?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DraftProjectFilterInput>>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  projectManager?: InputMaybe<UserFilterInput>;
  projectManagerId?: InputMaybe<UuidOperationFilterInput>;
  retentionPolicy?: InputMaybe<RetentionPolicyOperationFilterInput>;
  type?: InputMaybe<ProjectTypeOperationFilterInput>;
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type DraftProjectSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isConfidential?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orgId?: InputMaybe<SortEnumType>;
  projectManager?: InputMaybe<UserSortInput>;
  projectManagerId?: InputMaybe<SortEnumType>;
  retentionPolicy?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedDate?: InputMaybe<SortEnumType>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type FlExWsId = {
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
};

export type FlExWsIdFilterInput = {
  and?: InputMaybe<Array<FlExWsIdFilterInput>>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FlExWsIdFilterInput>>;
  tag?: InputMaybe<StringOperationFilterInput>;
};

export enum FeatureFlag {
  FwLiteBeta = 'FW_LITE_BETA'
}

export type FeatureFlagOperationFilterInput = {
  eq?: InputMaybe<FeatureFlag>;
  in?: InputMaybe<Array<FeatureFlag>>;
  neq?: InputMaybe<FeatureFlag>;
  nin?: InputMaybe<Array<FeatureFlag>>;
};

export type FlexProjectMetadata = {
  flexModelVersion?: Maybe<Scalars['Int']['output']>;
  langProjectId?: Maybe<Scalars['UUID']['output']>;
  lexEntryCount?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['UUID']['output'];
  writingSystems?: Maybe<ProjectWritingSystems>;
};

export type FlexProjectMetadataFilterInput = {
  and?: InputMaybe<Array<FlexProjectMetadataFilterInput>>;
  flexModelVersion?: InputMaybe<IntOperationFilterInput>;
  langProjectId?: InputMaybe<UuidOperationFilterInput>;
  lexEntryCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FlexProjectMetadataFilterInput>>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  writingSystems?: InputMaybe<ProjectWritingSystemsFilterInput>;
};

export type FlexProjectMetadataSortInput = {
  flexModelVersion?: InputMaybe<SortEnumType>;
  langProjectId?: InputMaybe<SortEnumType>;
  lexEntryCount?: InputMaybe<SortEnumType>;
  projectId?: InputMaybe<SortEnumType>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InvalidEmailError = Error & {
  address: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidOperationError = Error & {
  message: Scalars['String']['output'];
};

export type IsAdminResponse = {
  value: Scalars['Boolean']['output'];
};

export type LastMemberCantLeaveError = Error & {
  message: Scalars['String']['output'];
};

export type LeaveOrgError = LastMemberCantLeaveError | NotFoundError;

export type LeaveOrgInput = {
  orgId: Scalars['UUID']['input'];
};

export type LeaveOrgPayload = {
  errors?: Maybe<Array<LeaveOrgError>>;
  organization?: Maybe<Organization>;
};

export type LeaveProjectError = LastMemberCantLeaveError | NotFoundError;

export type LeaveProjectInput = {
  projectId: Scalars['UUID']['input'];
};

export type LeaveProjectPayload = {
  errors?: Maybe<Array<LeaveProjectError>>;
  project?: Maybe<Project>;
};

export type LexAuthUser = {
  audience: LexboxAudience;
  canCreateProjects?: Maybe<Scalars['Boolean']['output']>;
  createdByAdmin?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  featureFlags: Array<FeatureFlag>;
  hasFeature: Scalars['Boolean']['output'];
  hasScope: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgs: Array<AuthUserOrg>;
  projects: Array<AuthUserProject>;
  projectsJson: Scalars['String']['output'];
  role: UserRole;
  scopeString?: Maybe<Scalars['String']['output']>;
  scopes: Array<LexboxAuthScope>;
  updatedDate: Scalars['Long']['output'];
  username?: Maybe<Scalars['String']['output']>;
};


export type LexAuthUserHasFeatureArgs = {
  feature: FeatureFlag;
};


export type LexAuthUserHasScopeArgs = {
  scope: LexboxAuthScope;
};

export enum LexboxAudience {
  ForgotPassword = 'FORGOT_PASSWORD',
  LexboxApi = 'LEXBOX_API',
  RegisterAccount = 'REGISTER_ACCOUNT',
  SendAndReceive = 'SEND_AND_RECEIVE',
  SendAndReceiveRefresh = 'SEND_AND_RECEIVE_REFRESH',
  Unknown = 'UNKNOWN'
}

export enum LexboxAuthScope {
  Email = 'EMAIL',
  ForgotPassword = 'FORGOT_PASSWORD',
  LexboxApi = 'LEXBOX_API',
  Openid = 'OPENID',
  Profile = 'PROFILE',
  RegisterAccount = 'REGISTER_ACCOUNT',
  SendAndReceive = 'SEND_AND_RECEIVE',
  SendAndReceiveRefresh = 'SEND_AND_RECEIVE_REFRESH'
}

export type ListFeatureFlagOperationFilterInput = {
  all?: InputMaybe<FeatureFlagOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeatureFlagOperationFilterInput>;
  some?: InputMaybe<FeatureFlagOperationFilterInput>;
};

export type ListFilterInputTypeOfFlExWsIdFilterInput = {
  all?: InputMaybe<FlExWsIdFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FlExWsIdFilterInput>;
  some?: InputMaybe<FlExWsIdFilterInput>;
};

export type ListFilterInputTypeOfOrgMemberFilterInput = {
  all?: InputMaybe<OrgMemberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrgMemberFilterInput>;
  some?: InputMaybe<OrgMemberFilterInput>;
};

export type ListFilterInputTypeOfOrganizationFilterInput = {
  all?: InputMaybe<OrganizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganizationFilterInput>;
  some?: InputMaybe<OrganizationFilterInput>;
};

export type ListFilterInputTypeOfProjectFilterInput = {
  all?: InputMaybe<ProjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectFilterInput>;
  some?: InputMaybe<ProjectFilterInput>;
};

export type ListFilterInputTypeOfProjectUsersFilterInput = {
  all?: InputMaybe<ProjectUsersFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProjectUsersFilterInput>;
  some?: InputMaybe<ProjectUsersFilterInput>;
};

export type MeDto = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  addProjectMember: AddProjectMemberPayload;
  addProjectToOrg: AddProjectToOrgPayload;
  addProjectsToOrg: AddProjectsToOrgPayload;
  askToJoinProject: AskToJoinProjectPayload;
  bulkAddOrgMembers: BulkAddOrgMembersPayload;
  bulkAddProjectMembers: BulkAddProjectMembersPayload;
  changeOrgMemberRole: ChangeOrgMemberRolePayload;
  changeOrgName: ChangeOrgNamePayload;
  changeProjectDescription: ChangeProjectDescriptionPayload;
  changeProjectMemberRole: ChangeProjectMemberRolePayload;
  changeProjectName: ChangeProjectNamePayload;
  changeUserAccountByAdmin: ChangeUserAccountByAdminPayload;
  changeUserAccountBySelf: ChangeUserAccountBySelfPayload;
  createGuestUserByAdmin: CreateGuestUserByAdminPayload;
  createOrganization: CreateOrganizationPayload;
  createProject: CreateProjectPayload;
  deleteDraftProject: DeleteDraftProjectPayload;
  deleteOrg: DeleteOrgPayload;
  deleteUserByAdminOrSelf: DeleteUserByAdminOrSelfPayload;
  leaveOrg: LeaveOrgPayload;
  leaveProject: LeaveProjectPayload;
  removeProjectFromOrg: RemoveProjectFromOrgPayload;
  removeProjectMember: RemoveProjectMemberPayload;
  sendFWLiteBetaRequestEmail: SendFwLiteBetaRequestEmailPayload;
  sendNewVerificationEmailByAdmin: SendNewVerificationEmailByAdminPayload;
  setOrgMemberRole: SetOrgMemberRolePayload;
  setProjectConfidentiality: SetProjectConfidentialityPayload;
  setRetentionPolicy: SetRetentionPolicyPayload;
  setUserLocked: SetUserLockedPayload;
  softDeleteProject: SoftDeleteProjectPayload;
  updateFLExModelVersion: UpdateFlExModelVersionPayload;
  updateLangProjectId: UpdateLangProjectIdPayload;
  updateProjectLanguageList: UpdateProjectLanguageListPayload;
  updateProjectLexEntryCount: UpdateProjectLexEntryCountPayload;
  updateProjectRepoSizeInKb: UpdateProjectRepoSizeInKbPayload;
};


export type MutationAddProjectMemberArgs = {
  input: AddProjectMemberInput;
};


export type MutationAddProjectToOrgArgs = {
  input: AddProjectToOrgInput;
};


export type MutationAddProjectsToOrgArgs = {
  input: AddProjectsToOrgInput;
};


export type MutationAskToJoinProjectArgs = {
  input: AskToJoinProjectInput;
};


export type MutationBulkAddOrgMembersArgs = {
  input: BulkAddOrgMembersInput;
};


export type MutationBulkAddProjectMembersArgs = {
  input: BulkAddProjectMembersInput;
};


export type MutationChangeOrgMemberRoleArgs = {
  input: ChangeOrgMemberRoleInput;
};


export type MutationChangeOrgNameArgs = {
  input: ChangeOrgNameInput;
};


export type MutationChangeProjectDescriptionArgs = {
  input: ChangeProjectDescriptionInput;
};


export type MutationChangeProjectMemberRoleArgs = {
  input: ChangeProjectMemberRoleInput;
};


export type MutationChangeProjectNameArgs = {
  input: ChangeProjectNameInput;
};


export type MutationChangeUserAccountByAdminArgs = {
  input: ChangeUserAccountByAdminInput;
};


export type MutationChangeUserAccountBySelfArgs = {
  input: ChangeUserAccountBySelfInput;
};


export type MutationCreateGuestUserByAdminArgs = {
  input: CreateGuestUserByAdminInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationDeleteDraftProjectArgs = {
  input: DeleteDraftProjectInput;
};


export type MutationDeleteOrgArgs = {
  input: DeleteOrgInput;
};


export type MutationDeleteUserByAdminOrSelfArgs = {
  input: DeleteUserByAdminOrSelfInput;
};


export type MutationLeaveOrgArgs = {
  input: LeaveOrgInput;
};


export type MutationLeaveProjectArgs = {
  input: LeaveProjectInput;
};


export type MutationRemoveProjectFromOrgArgs = {
  input: RemoveProjectFromOrgInput;
};


export type MutationRemoveProjectMemberArgs = {
  input: RemoveProjectMemberInput;
};


export type MutationSendFwLiteBetaRequestEmailArgs = {
  input: SendFwLiteBetaRequestEmailInput;
};


export type MutationSendNewVerificationEmailByAdminArgs = {
  input: SendNewVerificationEmailByAdminInput;
};


export type MutationSetOrgMemberRoleArgs = {
  input: SetOrgMemberRoleInput;
};


export type MutationSetProjectConfidentialityArgs = {
  input: SetProjectConfidentialityInput;
};


export type MutationSetRetentionPolicyArgs = {
  input: SetRetentionPolicyInput;
};


export type MutationSetUserLockedArgs = {
  input: SetUserLockedInput;
};


export type MutationSoftDeleteProjectArgs = {
  input: SoftDeleteProjectInput;
};


export type MutationUpdateFlExModelVersionArgs = {
  input: UpdateFlExModelVersionInput;
};


export type MutationUpdateLangProjectIdArgs = {
  input: UpdateLangProjectIdInput;
};


export type MutationUpdateProjectLanguageListArgs = {
  input: UpdateProjectLanguageListInput;
};


export type MutationUpdateProjectLexEntryCountArgs = {
  input: UpdateProjectLexEntryCountInput;
};


export type MutationUpdateProjectRepoSizeInKbArgs = {
  input: UpdateProjectRepoSizeInKbInput;
};

export type NotFoundError = Error & {
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrgById = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<OrgByIdMember>;
  name: Scalars['String']['output'];
  projectCount: Scalars['Int']['output'];
  projects: Array<Project>;
  updatedDate: Scalars['DateTime']['output'];
};

export type OrgByIdMember = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  organization?: Maybe<Organization>;
  role: OrgRole;
  updatedDate: Scalars['DateTime']['output'];
  user: OrgByIdUser;
  userId: Scalars['UUID']['output'];
};

export type OrgByIdUser = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type OrgMember = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  orgId: Scalars['UUID']['output'];
  organization: Project;
  role: OrgRole;
  updatedDate: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UUID']['output'];
};

export type OrgMemberDto = {
  canCreateProjects: Scalars['Boolean']['output'];
  createdBy?: Maybe<OrgMemberDtoCreatedBy>;
  createdDate: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  id: Scalars['UUID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastActive: Scalars['DateTime']['output'];
  localizationCode: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type OrgMemberDtoCreatedBy = {
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type OrgMemberFilterInput = {
  and?: InputMaybe<Array<OrgMemberFilterInput>>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<OrgMemberFilterInput>>;
  orgId?: InputMaybe<UuidOperationFilterInput>;
  organization?: InputMaybe<OrganizationFilterInput>;
  role?: InputMaybe<OrgRoleOperationFilterInput>;
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type OrgMemberInvitedByEmail = Error & {
  message: Scalars['String']['output'];
};

export type OrgMemberRole = {
  role: OrgRole;
  username: Scalars['String']['output'];
};

export type OrgMembersMustBeVerified = Error & {
  message: Scalars['String']['output'];
};

export type OrgMembersMustBeVerifiedForRole = Error & {
  message: Scalars['String']['output'];
};

export type OrgProjects = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  org: Organization;
  orgId: Scalars['UUID']['output'];
  project: Project;
  projectId: Scalars['UUID']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export enum OrgRole {
  Admin = 'ADMIN',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type OrgRoleOperationFilterInput = {
  eq?: InputMaybe<OrgRole>;
  in?: InputMaybe<Array<OrgRole>>;
  neq?: InputMaybe<OrgRole>;
  nin?: InputMaybe<Array<OrgRole>>;
};

export type Organization = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<OrgMember>;
  name: Scalars['String']['output'];
  projectCount: Scalars['Int']['output'];
  projects: Array<Project>;
  updatedDate: Scalars['DateTime']['output'];
};

export type OrganizationFilterInput = {
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  memberCount?: InputMaybe<IntOperationFilterInput>;
  members?: InputMaybe<ListFilterInputTypeOfOrgMemberFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
  projectCount?: InputMaybe<IntOperationFilterInput>;
  projects?: InputMaybe<ListFilterInputTypeOfProjectFilterInput>;
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type OrganizationSortInput = {
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  memberCount?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectCount?: InputMaybe<SortEnumType>;
  updatedDate?: InputMaybe<SortEnumType>;
};

export type Project = {
  changesets: Array<Changeset>;
  code: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flexProjectMetadata?: Maybe<FlexProjectMetadata>;
  hasAbandonedTransactions: Scalars['Boolean']['output'];
  hasHarmonyCommits: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  isLanguageForgeProject: Scalars['Boolean']['output'];
  lastCommit?: Maybe<Scalars['DateTime']['output']>;
  migratedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organizations: Array<Organization>;
  parentId?: Maybe<Scalars['UUID']['output']>;
  projectOrigin: ProjectMigrationStatus;
  repoSizeInKb?: Maybe<Scalars['Int']['output']>;
  resetStatus: ResetStatus;
  retentionPolicy: RetentionPolicy;
  type: ProjectType;
  updatedDate: Scalars['DateTime']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<ProjectUsers>;
};

export type ProjectCreatorsMustHaveEmail = Error & {
  message: Scalars['String']['output'];
};

export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deletedDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  flexProjectMetadata?: InputMaybe<FlexProjectMetadataFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isConfidential?: InputMaybe<BooleanOperationFilterInput>;
  lastCommit?: InputMaybe<DateTimeOperationFilterInput>;
  migratedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  organizations?: InputMaybe<ListFilterInputTypeOfOrganizationFilterInput>;
  parentId?: InputMaybe<UuidOperationFilterInput>;
  projectOrigin?: InputMaybe<ProjectMigrationStatusOperationFilterInput>;
  repoSizeInKb?: InputMaybe<IntOperationFilterInput>;
  resetStatus?: InputMaybe<ResetStatusOperationFilterInput>;
  retentionPolicy?: InputMaybe<RetentionPolicyOperationFilterInput>;
  type?: InputMaybe<ProjectTypeOperationFilterInput>;
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  userCount?: InputMaybe<IntOperationFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfProjectUsersFilterInput>;
};

export type ProjectHasNoManagers = Error & {
  message: Scalars['String']['output'];
};

export type ProjectMemberInvitedByEmail = Error & {
  message: Scalars['String']['output'];
};

export type ProjectMembersMustBeVerified = Error & {
  message: Scalars['String']['output'];
};

export type ProjectMembersMustBeVerifiedForRole = Error & {
  message: Scalars['String']['output'];
};

export enum ProjectMigrationStatus {
  Migrated = 'MIGRATED',
  Migrating = 'MIGRATING',
  PrivateRedmine = 'PRIVATE_REDMINE',
  PublicRedmine = 'PUBLIC_REDMINE',
  Unknown = 'UNKNOWN'
}

export type ProjectMigrationStatusOperationFilterInput = {
  eq?: InputMaybe<ProjectMigrationStatus>;
  in?: InputMaybe<Array<ProjectMigrationStatus>>;
  neq?: InputMaybe<ProjectMigrationStatus>;
  nin?: InputMaybe<Array<ProjectMigrationStatus>>;
};

export enum ProjectRole {
  Editor = 'EDITOR',
  Manager = 'MANAGER',
  Observer = 'OBSERVER',
  Unknown = 'UNKNOWN'
}

export type ProjectRoleOperationFilterInput = {
  eq?: InputMaybe<ProjectRole>;
  in?: InputMaybe<Array<ProjectRole>>;
  neq?: InputMaybe<ProjectRole>;
  nin?: InputMaybe<Array<ProjectRole>>;
};

export type ProjectSortInput = {
  code?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deletedDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  flexProjectMetadata?: InputMaybe<FlexProjectMetadataSortInput>;
  id?: InputMaybe<SortEnumType>;
  isConfidential?: InputMaybe<SortEnumType>;
  lastCommit?: InputMaybe<SortEnumType>;
  migratedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  projectOrigin?: InputMaybe<SortEnumType>;
  repoSizeInKb?: InputMaybe<SortEnumType>;
  resetStatus?: InputMaybe<SortEnumType>;
  retentionPolicy?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  updatedDate?: InputMaybe<SortEnumType>;
  userCount?: InputMaybe<SortEnumType>;
};

export type ProjectStatus = {
  accessibleCode?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  exists: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
};

export enum ProjectType {
  AdaptIt = 'ADAPT_IT',
  FlEx = 'FL_EX',
  OneStoryEditor = 'ONE_STORY_EDITOR',
  OurWord = 'OUR_WORD',
  Unknown = 'UNKNOWN',
  WeSay = 'WE_SAY'
}

export type ProjectTypeOperationFilterInput = {
  eq?: InputMaybe<ProjectType>;
  in?: InputMaybe<Array<ProjectType>>;
  neq?: InputMaybe<ProjectType>;
  nin?: InputMaybe<Array<ProjectType>>;
};

export type ProjectUsers = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  project: Project;
  projectId: Scalars['UUID']['output'];
  role: ProjectRole;
  updatedDate: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['UUID']['output'];
};

export type ProjectUsersFilterInput = {
  and?: InputMaybe<Array<ProjectUsersFilterInput>>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<ProjectUsersFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<UuidOperationFilterInput>;
  role?: InputMaybe<ProjectRoleOperationFilterInput>;
  updatedDate?: InputMaybe<DateTimeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type ProjectWritingSystems = {
  analysisWss: Array<FlExWsId>;
  vernacularWss: Array<FlExWsId>;
};

export type ProjectWritingSystemsFilterInput = {
  analysisWss?: InputMaybe<ListFilterInputTypeOfFlExWsIdFilterInput>;
  and?: InputMaybe<Array<ProjectWritingSystemsFilterInput>>;
  or?: InputMaybe<Array<ProjectWritingSystemsFilterInput>>;
  vernacularWss?: InputMaybe<ListFilterInputTypeOfFlExWsIdFilterInput>;
};

export type ProjectsByLangCodeAndOrgInput = {
  langCode: Scalars['String']['input'];
  orgId: Scalars['UUID']['input'];
};

export type ProjectsInMyOrgInput = {
  orgId: Scalars['UUID']['input'];
};

export type Query = {
  draftProjects: Array<DraftProject>;
  isAdmin: IsAdminResponse;
  me?: Maybe<MeDto>;
  meAuth: LexAuthUser;
  myDraftProjects: Array<DraftProject>;
  myOrgs: Array<Organization>;
  myProjects: Array<Project>;
  orgById?: Maybe<OrgById>;
  orgMemberById?: Maybe<OrgMemberDto>;
  orgs: Array<Organization>;
  projectByCode?: Maybe<Project>;
  projectById?: Maybe<Project>;
  projectStatus: ProjectStatus;
  projects: Array<Project>;
  projectsByLangCodeAndOrg: Array<Project>;
  projectsInMyOrg: Array<Project>;
  testingThrowsError: LexAuthUser;
  users?: Maybe<UsersCollectionSegment>;
  usersICanSee?: Maybe<UsersICanSeeCollectionSegment>;
};


export type QueryDraftProjectsArgs = {
  orderBy?: InputMaybe<Array<DraftProjectSortInput>>;
  where?: InputMaybe<DraftProjectFilterInput>;
};


export type QueryMyDraftProjectsArgs = {
  orderBy?: InputMaybe<Array<DraftProjectSortInput>>;
};


export type QueryMyOrgsArgs = {
  orderBy?: InputMaybe<Array<OrganizationSortInput>>;
  where?: InputMaybe<OrganizationFilterInput>;
};


export type QueryMyProjectsArgs = {
  orderBy?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryOrgByIdArgs = {
  orgId: Scalars['UUID']['input'];
};


export type QueryOrgMemberByIdArgs = {
  orgId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type QueryOrgsArgs = {
  orderBy?: InputMaybe<Array<OrganizationSortInput>>;
  where?: InputMaybe<OrganizationFilterInput>;
};


export type QueryProjectByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryProjectByIdArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectStatusArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectsArgs = {
  orderBy?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
  withDeleted?: Scalars['Boolean']['input'];
};


export type QueryProjectsByLangCodeAndOrgArgs = {
  input: ProjectsByLangCodeAndOrgInput;
  orderBy?: InputMaybe<Array<ProjectSortInput>>;
};


export type QueryProjectsInMyOrgArgs = {
  input: ProjectsInMyOrgInput;
  orderBy?: InputMaybe<Array<ProjectSortInput>>;
  where?: InputMaybe<ProjectFilterInput>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryUsersICanSeeArgs = {
  orderBy?: InputMaybe<Array<UserSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserFilterInput>;
};

export type RemoveProjectFromOrgError = DbError | NotFoundError;

export type RemoveProjectFromOrgInput = {
  orgId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type RemoveProjectFromOrgPayload = {
  errors?: Maybe<Array<RemoveProjectFromOrgError>>;
  organization?: Maybe<Organization>;
};

export type RemoveProjectMemberInput = {
  projectId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type RemoveProjectMemberPayload = {
  project?: Maybe<Project>;
};

export type RequiredError = Error & {
  message: Scalars['String']['output'];
};

export enum ResetStatus {
  InProgress = 'IN_PROGRESS',
  None = 'NONE'
}

export type ResetStatusOperationFilterInput = {
  eq?: InputMaybe<ResetStatus>;
  in?: InputMaybe<Array<ResetStatus>>;
  neq?: InputMaybe<ResetStatus>;
  nin?: InputMaybe<Array<ResetStatus>>;
};

export enum RetentionPolicy {
  Dev = 'DEV',
  Test = 'TEST',
  Training = 'TRAINING',
  Unknown = 'UNKNOWN',
  Verified = 'VERIFIED'
}

export type RetentionPolicyOperationFilterInput = {
  eq?: InputMaybe<RetentionPolicy>;
  in?: InputMaybe<Array<RetentionPolicy>>;
  neq?: InputMaybe<RetentionPolicy>;
  nin?: InputMaybe<Array<RetentionPolicy>>;
};

export type SendFwLiteBetaRequestEmailError = NotFoundError;

export type SendFwLiteBetaRequestEmailInput = {
  name: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type SendFwLiteBetaRequestEmailPayload = {
  errors?: Maybe<Array<SendFwLiteBetaRequestEmailError>>;
  sendFWLiteBetaRequestEmailResult?: Maybe<SendFwLiteBetaRequestEmailResult>;
};

export enum SendFwLiteBetaRequestEmailResult {
  BetaAccessRequestSent = 'BETA_ACCESS_REQUEST_SENT',
  UserAlreadyInBeta = 'USER_ALREADY_IN_BETA'
}

export type SendNewVerificationEmailByAdminError = DbError | InvalidOperationError | NotFoundError;

export type SendNewVerificationEmailByAdminInput = {
  userId: Scalars['UUID']['input'];
};

export type SendNewVerificationEmailByAdminPayload = {
  errors?: Maybe<Array<SendNewVerificationEmailByAdminError>>;
  user?: Maybe<User>;
};

export type SetOrgMemberRoleError = DbError | NotFoundError | OrgMemberInvitedByEmail | OrgMembersMustBeVerified | OrgMembersMustBeVerifiedForRole;

export type SetOrgMemberRoleInput = {
  canInvite: Scalars['Boolean']['input'];
  emailOrUsername: Scalars['String']['input'];
  orgId: Scalars['UUID']['input'];
  role: OrgRole;
};

export type SetOrgMemberRolePayload = {
  errors?: Maybe<Array<SetOrgMemberRoleError>>;
  organization?: Maybe<Organization>;
};

export type SetProjectConfidentialityError = DbError | NotFoundError;

export type SetProjectConfidentialityInput = {
  isConfidential: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
};

export type SetProjectConfidentialityPayload = {
  errors?: Maybe<Array<SetProjectConfidentialityError>>;
  project?: Maybe<Project>;
};

export type SetRetentionPolicyError = DbError | NotFoundError;

export type SetRetentionPolicyInput = {
  projectId: Scalars['UUID']['input'];
  retentionPolicy: RetentionPolicy;
};

export type SetRetentionPolicyPayload = {
  errors?: Maybe<Array<SetRetentionPolicyError>>;
  project?: Maybe<Project>;
};

export type SetUserLockedError = NotFoundError;

export type SetUserLockedInput = {
  locked: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type SetUserLockedPayload = {
  errors?: Maybe<Array<SetUserLockedError>>;
  user?: Maybe<User>;
};

export type SoftDeleteProjectError = DbError | NotFoundError;

export type SoftDeleteProjectInput = {
  projectId: Scalars['UUID']['input'];
};

export type SoftDeleteProjectPayload = {
  errors?: Maybe<Array<SoftDeleteProjectError>>;
  project?: Maybe<Project>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  icontains?: InputMaybe<Scalars['String']['input']>;
  ieq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UnauthorizedAccessError = Error & {
  message: Scalars['String']['output'];
};

export type UniqueValueError = Error & {
  message: Scalars['String']['output'];
};

export type UpdateFlExModelVersionError = DbError | NotFoundError | UnauthorizedAccessError;

export type UpdateFlExModelVersionInput = {
  code: Scalars['String']['input'];
};

export type UpdateFlExModelVersionPayload = {
  errors?: Maybe<Array<UpdateFlExModelVersionError>>;
  project?: Maybe<Project>;
};

export type UpdateLangProjectIdError = DbError | NotFoundError | UnauthorizedAccessError;

export type UpdateLangProjectIdInput = {
  code: Scalars['String']['input'];
};

export type UpdateLangProjectIdPayload = {
  errors?: Maybe<Array<UpdateLangProjectIdError>>;
  project?: Maybe<Project>;
};

export type UpdateProjectLanguageListError = DbError | NotFoundError | UnauthorizedAccessError;

export type UpdateProjectLanguageListInput = {
  code: Scalars['String']['input'];
};

export type UpdateProjectLanguageListPayload = {
  errors?: Maybe<Array<UpdateProjectLanguageListError>>;
  project?: Maybe<Project>;
};

export type UpdateProjectLexEntryCountError = DbError | NotFoundError | UnauthorizedAccessError;

export type UpdateProjectLexEntryCountInput = {
  code: Scalars['String']['input'];
};

export type UpdateProjectLexEntryCountPayload = {
  errors?: Maybe<Array<UpdateProjectLexEntryCountError>>;
  project?: Maybe<Project>;
};

export type UpdateProjectRepoSizeInKbError = DbError | NotFoundError | UnauthorizedAccessError;

export type UpdateProjectRepoSizeInKbInput = {
  code: Scalars['String']['input'];
};

export type UpdateProjectRepoSizeInKbPayload = {
  errors?: Maybe<Array<UpdateProjectRepoSizeInKbError>>;
  project?: Maybe<Project>;
};

export type User = {
  canCreateProjects: Scalars['Boolean']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']['output']>;
  createdDate: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  featureFlags: Array<FeatureFlag>;
  id: Scalars['UUID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastActive: Scalars['DateTime']['output'];
  localizationCode: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizations: Array<OrgMember>;
  passwordStrength?: Maybe<Scalars['Int']['output']>;
  projects: Array<ProjectUsers>;
  updatedDate: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  usersICreated: Array<User>;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  createdById?: InputMaybe<UuidOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  featureFlags?: InputMaybe<ListFeatureFlagOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isAdmin?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type UserProjectRole = {
  role: ProjectRole;
  username: Scalars['String']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserSortInput = {
  createdDate?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UsersCollectionSegment = {
  /** A flattened list of the items. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type UsersICanSeeCollectionSegment = {
  /** A flattened list of the items. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeleteUserByAdminOrSelfMutationVariables = Exact<{
  input: DeleteUserByAdminOrSelfInput;
}>;


export type DeleteUserByAdminOrSelfMutation = { deleteUserByAdminOrSelf: { user?: { id: string } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type SoftDeleteProjectMutationVariables = Exact<{
  input: SoftDeleteProjectInput;
}>;


export type SoftDeleteProjectMutation = { softDeleteProject: { project?: { id: string, deletedDate?: string | Date | null } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type DeleteDraftProjectMutationVariables = Exact<{
  input: DeleteDraftProjectInput;
}>;


export type DeleteDraftProjectMutation = { deleteDraftProject: { draftProject?: { id: string } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type LoadAdminUsersTypeaheadQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  take: Scalars['Int']['input'];
}>;


export type LoadAdminUsersTypeaheadQuery = { users?: { totalCount: number, items?: Array<{ id: string, name: string, email?: string | null, username?: string | null, projects: Array<{ id: string, role: ProjectRole, project: { id: string, code: string, name: string } }> }> | null } | null };

export type LoadUsersICanSeeTypeaheadQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  take: Scalars['Int']['input'];
}>;


export type LoadUsersICanSeeTypeaheadQuery = { usersICanSee?: { totalCount: number, items?: Array<{ id: string, name: string }> | null } | null };

export type LoadProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadProjectsQuery = { myProjects: Array<{ code: string, id: string, name: string, lastCommit?: string | Date | null, userCount: number, type: ProjectType, isConfidential?: boolean | null }>, myDraftProjects: Array<{ code: string, createdDate: string | Date, id: string, name: string, type: ProjectType, description: string, retentionPolicy: RetentionPolicy, isConfidential?: boolean | null, orgId?: string | null, projectManagerId?: string | null }> };

export type LoadAdminDashboardProjectsQueryVariables = Exact<{
  withDeletedProjects: Scalars['Boolean']['input'];
  projectFilter?: InputMaybe<ProjectFilterInput>;
  draftFilter?: InputMaybe<DraftProjectFilterInput>;
}>;


export type LoadAdminDashboardProjectsQuery = { projects: Array<{ code: string, id: string, name: string, lastCommit?: string | Date | null, type: ProjectType, isConfidential?: boolean | null, deletedDate?: string | Date | null, createdDate: string | Date, userCount: number }>, draftProjects: Array<{ code: string, id: string, name: string, type: ProjectType, createdDate: string | Date, description: string, retentionPolicy: RetentionPolicy, isConfidential?: boolean | null, projectManagerId?: string | null, orgId?: string | null }> };

export type LoadAdminDashboardUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  take: Scalars['Int']['input'];
}>;


export type LoadAdminDashboardUsersQuery = { users?: { totalCount: number, items?: Array<{ id: string, name: string, email?: string | null, username?: string | null, isAdmin: boolean, emailVerified: boolean, createdDate: string | Date, locked: boolean, localizationCode: string, updatedDate: string | Date, lastActive: string | Date, canCreateProjects: boolean, featureFlags: Array<FeatureFlag>, createdById?: string | null, createdBy?: { id: string, name: string } | null, projects: Array<{ id: string, projectId: string }> }> | null } | null };

export type ChangeUserAccountByAdminMutationVariables = Exact<{
  input: ChangeUserAccountByAdminInput;
}>;


export type ChangeUserAccountByAdminMutation = { changeUserAccountByAdmin: { user?: { id: string, name: string, email?: string | null, isAdmin: boolean, featureFlags: Array<FeatureFlag>, emailVerified: boolean } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UniqueValueError', message: string }> | null } };

export type SendNewVerificationEmailByAdminMutationVariables = Exact<{
  input: SendNewVerificationEmailByAdminInput;
}>;


export type SendNewVerificationEmailByAdminMutation = { sendNewVerificationEmailByAdmin: { user?: { id: string, email?: string | null, emailVerified: boolean } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'InvalidOperationError', message: string } | { __typename: 'NotFoundError', message: string }> | null } };

export type CreateGuestUserByAdminMutationVariables = Exact<{
  input: CreateGuestUserByAdminInput;
}>;


export type CreateGuestUserByAdminMutation = { createGuestUserByAdmin: { lexAuthUser?: { id: string, name: string, email?: string | null, username?: string | null, role: UserRole, isAdmin: boolean, locked?: boolean | null, emailVerificationRequired?: boolean | null, canCreateProjects?: boolean | null, createdByAdmin?: boolean | null, locale: string, featureFlags: Array<FeatureFlag>, audience: LexboxAudience, projects: Array<{ projectId: string, role: ProjectRole }>, orgs: Array<{ orgId: string, role: OrgRole }> } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'RequiredError', message: string } | { __typename: 'UniqueValueError', message: string }> | null } };

export type SetUserLockedMutationVariables = Exact<{
  input: SetUserLockedInput;
}>;


export type SetUserLockedMutation = { setUserLocked: { user?: { id: string, locked: boolean } | null, errors?: Array<{ __typename: 'NotFoundError', message: string }> | null } };

export type OrgPageQueryVariables = Exact<{
  orgId: Scalars['UUID']['input'];
}>;


export type OrgPageQuery = { orgById?: { id: string, createdDate: string | Date, updatedDate: string | Date, name: string, projects: Array<{ id: string, isConfidential?: boolean | null, code: string, name: string, type: ProjectType, userCount: number }>, members: Array<{ id: string, role: OrgRole, user: { id: string, name: string, username?: string | null, email?: string | null } }> } | null };

export type ChangeOrgNameMutationVariables = Exact<{
  input: ChangeOrgNameInput;
}>;


export type ChangeOrgNameMutation = { changeOrgName: { organization?: { id: string, name: string } | null, errors?: Array<{ message: string } | { message: string } | { message: string }> | null } };

export type DeleteOrgUserMutationVariables = Exact<{
  input: ChangeOrgMemberRoleInput;
}>;


export type DeleteOrgUserMutation = { changeOrgMemberRole: { organization?: { id: string } | null } };

export type LeaveOrgMutationVariables = Exact<{
  input: LeaveOrgInput;
}>;


export type LeaveOrgMutation = { leaveOrg: { organization?: { id: string } | null, errors?: Array<{ __typename: 'LastMemberCantLeaveError' } | { __typename: 'NotFoundError' }> | null } };

export type AddOrgMemberMutationVariables = Exact<{
  memberInput: SetOrgMemberRoleInput;
  projectsInput: AddProjectsToOrgInput;
}>;


export type AddOrgMemberMutation = { setOrgMemberRole: { organization?: { id: string } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'OrgMemberInvitedByEmail', message: string } | { __typename: 'OrgMembersMustBeVerified', message: string } | { __typename: 'OrgMembersMustBeVerifiedForRole', message: string }> | null }, addProjectsToOrg: { orgById?: { id: string, projects: Array<{ id: string }> } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string }> | null } };

export type BulkAddOrgMembersMutationVariables = Exact<{
  input: BulkAddOrgMembersInput;
}>;


export type BulkAddOrgMembersMutation = { bulkAddOrgMembers: { bulkAddOrgMembersResult?: { addedMembers: Array<{ username: string, role: OrgRole }>, existingMembers: Array<{ username: string, role: OrgRole }>, notFoundMembers: Array<{ username: string, role: OrgRole }> } | null, errors?: Array<{ __typename: 'DbError' } | { __typename: 'NotFoundError' } | { __typename: 'UnauthorizedAccessError' }> | null } };

export type RemoveProjectFromOrgMutationVariables = Exact<{
  input: RemoveProjectFromOrgInput;
}>;


export type RemoveProjectFromOrgMutation = { removeProjectFromOrg: { organization?: { id: string } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string }> | null } };

export type OrgMemberByIdQueryVariables = Exact<{
  orgId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type OrgMemberByIdQuery = { orgMemberById?: { id: string, name: string, email?: string | null, emailVerified: boolean, isAdmin: boolean, createdDate: string | Date, username?: string | null, locked: boolean, localizationCode: string, updatedDate: string | Date, lastActive: string | Date, featureFlags: Array<FeatureFlag>, canCreateProjects: boolean, createdBy?: { id: string, name: string } | null } | null };

export type ChangeOrgMemberRoleMutationVariables = Exact<{
  input: ChangeOrgMemberRoleInput;
}>;


export type ChangeOrgMemberRoleMutation = { changeOrgMemberRole: { organization?: { id: string } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'OrgMembersMustBeVerified', message: string } | { __typename: 'OrgMembersMustBeVerifiedForRole', message: string }> | null } };

export type DeleteOrgMutationVariables = Exact<{
  input: DeleteOrgInput;
}>;


export type DeleteOrgMutation = { deleteOrg: { organization?: { id: string, name: string } | null } };

export type LoadMyProjectsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type LoadMyProjectsQuery = { myProjects: Array<{ code: string, id: string, name: string, users: Array<{ id: string, userId: string, role: ProjectRole }> }> };

export type AddProjectsToOrgMutationVariables = Exact<{
  input: AddProjectsToOrgInput;
}>;


export type AddProjectsToOrgMutation = { addProjectsToOrg: { orgById?: { id: string, projects: Array<{ id: string }> } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string }> | null } };

export type CreateOrgMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrgMutation = { createOrganization: { organization?: { id: string } | null, errors?: Array<{ code: DbErrorCode }> | null } };

export type OrgListPageQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgListPageQuery = { orgs: Array<{ id: string, name: string, createdDate: string | Date, memberCount: number }>, myOrgs: Array<{ id: string }> };

export type ChangesetsFragment = { changesets: Array<{ node: string, rev: number, parents: Array<string>, date: Array<number>, user: string, desc: string }> };

export type ProjectPageQueryVariables = Exact<{
  projectCode: Scalars['String']['input'];
  userIsAdmin: Scalars['Boolean']['input'];
}>;


export type ProjectPageQuery = { projectByCode?: { id: string, name: string, code: string, description?: string | null, type: ProjectType, resetStatus: ResetStatus, lastCommit?: string | Date | null, repoSizeInKb?: number | null, createdDate: string | Date, retentionPolicy: RetentionPolicy, isConfidential?: boolean | null, isLanguageForgeProject: boolean, hasHarmonyCommits: boolean, organizations: Array<{ id: string, name: string }>, users: Array<{ id: string, role: ProjectRole, user: { locked: boolean, username?: string | null, createdDate: string | Date, updatedDate: string | Date, email?: string | null, localizationCode: string, lastActive: string | Date, canCreateProjects: boolean, featureFlags: Array<FeatureFlag>, isAdmin: boolean, emailVerified: boolean, id: string, name: string, createdBy?: { id: string, name: string } | null } }>, flexProjectMetadata?: { lexEntryCount?: number | null, flexModelVersion?: number | null, writingSystems?: { vernacularWss: Array<{ tag: string, isActive: boolean, isDefault: boolean }>, analysisWss: Array<{ tag: string, isActive: boolean, isDefault: boolean }> } | null } | null } | null };

export type ProjectChangesetsQueryVariables = Exact<{
  projectCode: Scalars['String']['input'];
}>;


export type ProjectChangesetsQuery = { projectByCode?: { id: string, code: string, changesets: Array<{ node: string, rev: number, parents: Array<string>, date: Array<number>, user: string, desc: string }> } | null };

export type LoadOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadOrgsQuery = { orgs: Array<{ id: string, name: string }> };

export type LoadMyOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadMyOrgsQuery = { myOrgs: Array<{ id: string, name: string }> };

export type AddProjectToOrgMutationVariables = Exact<{
  input: AddProjectToOrgInput;
}>;


export type AddProjectToOrgMutation = { addProjectToOrg: { organization?: { id: string } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string }> | null } };

export type AddProjectMemberMutationVariables = Exact<{
  input: AddProjectMemberInput;
}>;


export type AddProjectMemberMutation = { addProjectMember: { project?: { id: string, users: Array<{ id: string, role: ProjectRole, user: { id: string, name: string } }> } | null, errors?: Array<{ __typename: 'AlreadyExistsError', message: string } | { __typename: 'DbError', message: string } | { __typename: 'InvalidEmailError', message: string, address: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'ProjectMemberInvitedByEmail', message: string } | { __typename: 'ProjectMembersMustBeVerified', message: string } | { __typename: 'ProjectMembersMustBeVerifiedForRole', message: string }> | null } };

export type BulkAddProjectMembersMutationVariables = Exact<{
  input: BulkAddProjectMembersInput;
}>;


export type BulkAddProjectMembersMutation = { bulkAddProjectMembers: { bulkAddProjectMembersResult?: { addedMembers: Array<{ username: string, role: ProjectRole }>, createdMembers: Array<{ username: string, role: ProjectRole }>, existingMembers: Array<{ username: string, role: ProjectRole }> } | null, errors?: Array<{ __typename: 'DbError' } | { __typename: 'InvalidEmailError', message: string, address: string } | { __typename: 'NotFoundError' }> | null } };

export type UpdateProjectRepoSizeInKbMutationVariables = Exact<{
  input: UpdateProjectRepoSizeInKbInput;
}>;


export type UpdateProjectRepoSizeInKbMutation = { updateProjectRepoSizeInKb: { project?: { id: string, repoSizeInKb?: number | null } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedAccessError', message: string }> | null } };

export type UpdateProjectLexEntryCountMutationVariables = Exact<{
  input: UpdateProjectLexEntryCountInput;
}>;


export type UpdateProjectLexEntryCountMutation = { updateProjectLexEntryCount: { project?: { id: string, flexProjectMetadata?: { lexEntryCount?: number | null } | null } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedAccessError', message: string }> | null } };

export type UpdateFlExModelVersionMutationVariables = Exact<{
  input: UpdateFlExModelVersionInput;
}>;


export type UpdateFlExModelVersionMutation = { updateFLExModelVersion: { project?: { id: string, flexProjectMetadata?: { flexModelVersion?: number | null } | null } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedAccessError', message: string }> | null } };

export type UpdateLangProjectIdMutationVariables = Exact<{
  input: UpdateLangProjectIdInput;
}>;


export type UpdateLangProjectIdMutation = { updateLangProjectId: { project?: { id: string, flexProjectMetadata?: { langProjectId?: string | null } | null } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedAccessError', message: string }> | null } };

export type UpdateProjectLanguageListMutationVariables = Exact<{
  input: UpdateProjectLanguageListInput;
}>;


export type UpdateProjectLanguageListMutation = { updateProjectLanguageList: { project?: { id: string, flexProjectMetadata?: { writingSystems?: { analysisWss: Array<{ tag: string, isActive: boolean, isDefault: boolean }>, vernacularWss: Array<{ tag: string, isActive: boolean, isDefault: boolean }> } | null } | null } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedAccessError', message: string }> | null } };

export type ChangeProjectMemberRoleMutationVariables = Exact<{
  input: ChangeProjectMemberRoleInput;
}>;


export type ChangeProjectMemberRoleMutation = { changeProjectMemberRole: { projectUsers?: { id: string, role: ProjectRole } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'ProjectMembersMustBeVerified', message: string } | { __typename: 'ProjectMembersMustBeVerifiedForRole', message: string }> | null } };

export type ChangeProjectNameMutationVariables = Exact<{
  input: ChangeProjectNameInput;
}>;


export type ChangeProjectNameMutation = { changeProjectName: { project?: { id: string, name: string } | null, errors?: Array<{ message: string } | { message: string } | { message: string }> | null } };

export type ChangeProjectDescriptionMutationVariables = Exact<{
  input: ChangeProjectDescriptionInput;
}>;


export type ChangeProjectDescriptionMutation = { changeProjectDescription: { project?: { id: string, description?: string | null } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type SetProjectConfidentialityMutationVariables = Exact<{
  input: SetProjectConfidentialityInput;
}>;


export type SetProjectConfidentialityMutation = { setProjectConfidentiality: { project?: { id: string, isConfidential?: boolean | null } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type SetRetentionPolicyMutationVariables = Exact<{
  input: SetRetentionPolicyInput;
}>;


export type SetRetentionPolicyMutation = { setRetentionPolicy: { project?: { id: string, retentionPolicy: RetentionPolicy } | null, errors?: Array<{ message: string } | { message: string }> | null } };

export type DeleteProjectUserMutationVariables = Exact<{
  input: RemoveProjectMemberInput;
}>;


export type DeleteProjectUserMutation = { removeProjectMember: { project?: { id: string, users: Array<{ id: string, role: ProjectRole, user: { id: string, name: string } }> } | null } };

export type RefreshProjectStatusQueryVariables = Exact<{
  projectCode: Scalars['String']['input'];
}>;


export type RefreshProjectStatusQuery = { projectByCode?: { id: string, resetStatus: ResetStatus, lastCommit?: string | Date | null, hasHarmonyCommits: boolean, changesets: Array<{ node: string, rev: number, parents: Array<string>, date: Array<number>, user: string, desc: string }> } | null };

export type LeaveProjectMutationVariables = Exact<{
  input: LeaveProjectInput;
}>;


export type LeaveProjectMutation = { leaveProject: { project?: { id: string } | null, errors?: Array<{ __typename: 'LastMemberCantLeaveError' } | { __typename: 'NotFoundError' }> | null } };

export type ViewerProjectQueryVariables = Exact<{
  projectCode: Scalars['String']['input'];
}>;


export type ViewerProjectQuery = { projectByCode?: { id: string, name: string, code: string } | null };

export type LoadRequestingUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type LoadRequestingUserQuery = { users?: { items?: Array<{ id: string, name: string, email?: string | null, username?: string | null, isAdmin: boolean, emailVerified: boolean, createdDate: string | Date, locked: boolean, localizationCode: string, updatedDate: string | Date, lastActive: string | Date, canCreateProjects: boolean }> | null } | null };

export type LoadProjectStatusQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type LoadProjectStatusQuery = { projectStatus: { id: string, exists: boolean, deleted: boolean, accessibleCode?: string | null } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { createProject: { createProjectResponse?: { id: string, result: CreateProjectResult } | null, errors?: Array<{ code: DbErrorCode } | {}> | null } };

export type ProjectsByLangCodeAndOrgQueryVariables = Exact<{
  input: ProjectsByLangCodeAndOrgInput;
}>;


export type ProjectsByLangCodeAndOrgQuery = { projectsByLangCodeAndOrg: Array<{ id: string, code: string, name: string, description?: string | null }> };

export type ProjectsByNameAndOrgQueryVariables = Exact<{
  input: ProjectsInMyOrgInput;
  filter?: InputMaybe<ProjectFilterInput>;
}>;


export type ProjectsByNameAndOrgQuery = { projectsInMyOrg: Array<{ id: string, code: string, name: string, description?: string | null }> };

export type AskToJoinProjectMutationVariables = Exact<{
  input: AskToJoinProjectInput;
}>;


export type AskToJoinProjectMutation = { askToJoinProject: { project?: { id: string } | null, errors?: Array<{ __typename: 'DbError', code: DbErrorCode } | { __typename: 'NotFoundError' } | { __typename: 'ProjectHasNoManagers' } | { __typename: 'ProjectMembersMustBeVerified' } | { __typename: 'ProjectMembersMustBeVerifiedForRole' }> | null } };

export type UserPageQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPageQuery = { me?: { id: string, name: string, email?: string | null, locale: string } | null };

export type ChangeUserAccountBySelfMutationVariables = Exact<{
  input: ChangeUserAccountBySelfInput;
}>;


export type ChangeUserAccountBySelfMutation = { changeUserAccountBySelf: { meDto?: { id: string, name: string, email?: string | null, locale: string } | null, errors?: Array<{ __typename: 'DbError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UniqueValueError', message: string }> | null } };

export type SendFwLiteBetaRequestEmailMutationVariables = Exact<{
  input: SendFwLiteBetaRequestEmailInput;
}>;


export type SendFwLiteBetaRequestEmailMutation = { sendFWLiteBetaRequestEmail: { sendFWLiteBetaRequestEmailResult?: SendFwLiteBetaRequestEmailResult | null, errors?: Array<{ __typename: 'NotFoundError', message: string }> | null } };

export type Sandbox500QueryVariables = Exact<{ [key: string]: never; }>;


export type Sandbox500Query = { testingThrowsError: { id: string } };

export const ChangesetsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changesets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changesets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"}},{"kind":"Field","name":{"kind":"Name","value":"rev"}},{"kind":"Field","name":{"kind":"Name","value":"parents"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}}]}}]}}]} as unknown as DocumentNode<ChangesetsFragment, unknown>;
export const DeleteUserByAdminOrSelfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserByAdminOrSelf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserByAdminOrSelfInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserByAdminOrSelf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteUserByAdminOrSelfMutation, DeleteUserByAdminOrSelfMutationVariables>;
export const SoftDeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SoftDeleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SoftDeleteProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"softDeleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deletedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SoftDeleteProjectMutation, SoftDeleteProjectMutationVariables>;
export const DeleteDraftProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDraftProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteDraftProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDraftProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftProject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteDraftProjectMutation, DeleteDraftProjectMutationVariables>;
export const LoadAdminUsersTypeaheadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadAdminUsersTypeahead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoadAdminUsersTypeaheadQuery, LoadAdminUsersTypeaheadQueryVariables>;
export const LoadUsersICanSeeTypeaheadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadUsersICanSeeTypeahead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersICanSee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LoadUsersICanSeeTypeaheadQuery, LoadUsersICanSeeTypeaheadQueryVariables>;
export const LoadProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadProjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommit"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myDraftProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"retentionPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}},{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"projectManagerId"}}]}}]}}]} as unknown as DocumentNode<LoadProjectsQuery, LoadProjectsQueryVariables>;
export const LoadAdminDashboardProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadAdminDashboardProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withDeletedProjects"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"draftFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DraftProjectFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"withDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withDeletedProjects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}},{"kind":"Field","name":{"kind":"Name","value":"deletedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draftProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"draftFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"retentionPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}},{"kind":"Field","name":{"kind":"Name","value":"projectManagerId"}},{"kind":"Field","name":{"kind":"Name","value":"orgId"}}]}}]}}]} as unknown as DocumentNode<LoadAdminDashboardProjectsQuery, LoadAdminDashboardProjectsQueryVariables>;
export const LoadAdminDashboardUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadAdminDashboardUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"localizationCode"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastActive"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateProjects"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"createdById"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoadAdminDashboardUsersQuery, LoadAdminDashboardUsersQueryVariables>;
export const ChangeUserAccountByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeUserAccountByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeUserAccountByAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeUserAccountByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeUserAccountByAdminMutation, ChangeUserAccountByAdminMutationVariables>;
export const SendNewVerificationEmailByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendNewVerificationEmailByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendNewVerificationEmailByAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNewVerificationEmailByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendNewVerificationEmailByAdminMutation, SendNewVerificationEmailByAdminMutationVariables>;
export const CreateGuestUserByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGuestUserByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGuestUserByAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGuestUserByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lexAuthUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerificationRequired"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateProjects"}},{"kind":"Field","name":{"kind":"Name","value":"createdByAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateGuestUserByAdminMutation, CreateGuestUserByAdminMutationVariables>;
export const SetUserLockedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserLocked"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetUserLockedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserLocked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetUserLockedMutation, SetUserLockedMutationVariables>;
export const OrgPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orgPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrgPageQuery, OrgPageQueryVariables>;
export const ChangeOrgNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOrgName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOrgNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOrgName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeOrgNameMutation, ChangeOrgNameMutationVariables>;
export const DeleteOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOrgMemberRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOrgMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrgUserMutation, DeleteOrgUserMutationVariables>;
export const LeaveOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeaveOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveOrgMutation, LeaveOrgMutationVariables>;
export const AddOrgMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrgMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetOrgMemberRoleInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProjectsToOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOrgMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addProjectsToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgById"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddOrgMemberMutation, AddOrgMemberMutationVariables>;
export const BulkAddOrgMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkAddOrgMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkAddOrgMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkAddOrgMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkAddOrgMembersResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notFoundMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<BulkAddOrgMembersMutation, BulkAddOrgMembersMutationVariables>;
export const RemoveProjectFromOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProjectFromOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProjectFromOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProjectFromOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveProjectFromOrgMutation, RemoveProjectFromOrgMutationVariables>;
export const OrgMemberByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgMemberById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgMemberById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"localizationCode"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastActive"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateProjects"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OrgMemberByIdQuery, OrgMemberByIdQueryVariables>;
export const ChangeOrgMemberRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOrgMemberRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeOrgMemberRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOrgMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeOrgMemberRoleMutation, ChangeOrgMemberRoleMutationVariables>;
export const DeleteOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOrgMutation, DeleteOrgMutationVariables>;
export const LoadMyProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadMyProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"MANAGER"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<LoadMyProjectsQuery, LoadMyProjectsQueryVariables>;
export const AddProjectsToOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProjectsToOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProjectsToOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProjectsToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgById"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddProjectsToOrgMutation, AddProjectsToOrgMutationVariables>;
export const CreateOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DbError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrgMutation, CreateOrgMutationVariables>;
export const OrgListPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orgListPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"memberCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myOrgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OrgListPageQuery, OrgListPageQueryVariables>;
export const ProjectPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIsAdmin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"resetStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommit"}},{"kind":"Field","name":{"kind":"Name","value":"repoSizeInKb"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"retentionPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}},{"kind":"Field","name":{"kind":"Name","value":"isLanguageForgeProject"}},{"kind":"Field","name":{"kind":"Name","value":"hasHarmonyCommits"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIsAdmin"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"localizationCode"}},{"kind":"Field","name":{"kind":"Name","value":"lastActive"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateProjects"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlags"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flexProjectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lexEntryCount"}},{"kind":"Field","name":{"kind":"Name","value":"flexModelVersion"}},{"kind":"Field","name":{"kind":"Name","value":"writingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vernacularWss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysisWss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectPageQuery, ProjectPageQueryVariables>;
export const ProjectChangesetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectChangesets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changesets"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changesets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changesets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"}},{"kind":"Field","name":{"kind":"Name","value":"rev"}},{"kind":"Field","name":{"kind":"Name","value":"parents"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}}]}}]}}]} as unknown as DocumentNode<ProjectChangesetsQuery, ProjectChangesetsQueryVariables>;
export const LoadOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadOrgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<LoadOrgsQuery, LoadOrgsQueryVariables>;
export const LoadMyOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadMyOrgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myOrgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<LoadMyOrgsQuery, LoadMyOrgsQueryVariables>;
export const AddProjectToOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProjectToOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProjectToOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProjectToOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddProjectToOrgMutation, AddProjectToOrgMutationVariables>;
export const AddProjectMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProjectMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProjectMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProjectMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEmailError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddProjectMemberMutation, AddProjectMemberMutationVariables>;
export const BulkAddProjectMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkAddProjectMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkAddProjectMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkAddProjectMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkAddProjectMembersResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"existingMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEmailError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BulkAddProjectMembersMutation, BulkAddProjectMembersMutationVariables>;
export const UpdateProjectRepoSizeInKbDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectRepoSizeInKb"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectRepoSizeInKbInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectRepoSizeInKb"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"repoSizeInKb"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectRepoSizeInKbMutation, UpdateProjectRepoSizeInKbMutationVariables>;
export const UpdateProjectLexEntryCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectLexEntryCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectLexEntryCountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectLexEntryCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexProjectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lexEntryCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectLexEntryCountMutation, UpdateProjectLexEntryCountMutationVariables>;
export const UpdateFlExModelVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFLExModelVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFLExModelVersionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFLExModelVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexProjectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flexModelVersion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFlExModelVersionMutation, UpdateFlExModelVersionMutationVariables>;
export const UpdateLangProjectIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLangProjectId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLangProjectIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLangProjectId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexProjectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"langProjectId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLangProjectIdMutation, UpdateLangProjectIdMutationVariables>;
export const UpdateProjectLanguageListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProjectLanguageList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProjectLanguageListInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProjectLanguageList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexProjectMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analysisWss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vernacularWss"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectLanguageListMutation, UpdateProjectLanguageListMutationVariables>;
export const ChangeProjectMemberRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeProjectMemberRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeProjectMemberRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeProjectMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeProjectMemberRoleMutation, ChangeProjectMemberRoleMutationVariables>;
export const ChangeProjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeProjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeProjectNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeProjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeProjectNameMutation, ChangeProjectNameMutationVariables>;
export const ChangeProjectDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeProjectDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeProjectDescriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeProjectDescription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeProjectDescriptionMutation, ChangeProjectDescriptionMutationVariables>;
export const SetProjectConfidentialityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetProjectConfidentiality"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetProjectConfidentialityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setProjectConfidentiality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isConfidential"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetProjectConfidentialityMutation, SetProjectConfidentialityMutationVariables>;
export const SetRetentionPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetRetentionPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetRetentionPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setRetentionPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retentionPolicy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetRetentionPolicyMutation, SetRetentionPolicyMutationVariables>;
export const DeleteProjectUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProjectUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProjectMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProjectMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectUserMutation, DeleteProjectUserMutationVariables>;
export const RefreshProjectStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"refreshProjectStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resetStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommit"}},{"kind":"Field","name":{"kind":"Name","value":"hasHarmonyCommits"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Changesets"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Changesets"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changesets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"}},{"kind":"Field","name":{"kind":"Name","value":"rev"}},{"kind":"Field","name":{"kind":"Name","value":"parents"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}}]}}]}}]} as unknown as DocumentNode<RefreshProjectStatusQuery, RefreshProjectStatusQueryVariables>;
export const LeaveProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeaveProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]} as unknown as DocumentNode<LeaveProjectMutation, LeaveProjectMutationVariables>;
export const ViewerProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"viewerProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectByCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<ViewerProjectQuery, ViewerProjectQueryVariables>;
export const LoadRequestingUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadRequestingUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"localizationCode"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastActive"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateProjects"}}]}}]}}]}}]} as unknown as DocumentNode<LoadRequestingUserQuery, LoadRequestingUserQueryVariables>;
export const LoadProjectStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadProjectStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"exists"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"accessibleCode"}}]}}]}}]} as unknown as DocumentNode<LoadProjectStatusQuery, LoadProjectStatusQueryVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProjectResponse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DbError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const ProjectsByLangCodeAndOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsByLangCodeAndOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectsByLangCodeAndOrgInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsByLangCodeAndOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProjectsByLangCodeAndOrgQuery, ProjectsByLangCodeAndOrgQueryVariables>;
export const ProjectsByNameAndOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsByNameAndOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectsInMyOrgInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsInMyOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProjectsByNameAndOrgQuery, ProjectsByNameAndOrgQueryVariables>;
export const AskToJoinProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"askToJoinProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AskToJoinProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askToJoinProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DbError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AskToJoinProjectMutation, AskToJoinProjectMutationVariables>;
export const UserPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]} as unknown as DocumentNode<UserPageQuery, UserPageQueryVariables>;
export const ChangeUserAccountBySelfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeUserAccountBySelf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeUserAccountBySelfInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeUserAccountBySelf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meDto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeUserAccountBySelfMutation, ChangeUserAccountBySelfMutationVariables>;
export const SendFwLiteBetaRequestEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFWLiteBetaRequestEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendFWLiteBetaRequestEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFWLiteBetaRequestEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFWLiteBetaRequestEmailResult"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Error"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendFwLiteBetaRequestEmailMutation, SendFwLiteBetaRequestEmailMutationVariables>;
export const Sandbox500Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sandbox500"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testingThrowsError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Sandbox500Query, Sandbox500QueryVariables>;